export enum CardSizes {
  XS = 'xs',
  SMALL = 'small',
  DEFAULT = 'default'
}
